// Generated by purs version 0.15.0
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Map_Internal from "../Data.Map.Internal/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Set from "../Data.Set/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Data_Unfoldable from "../Data.Unfoldable/index.js";
var take = function (dictOrd) {
    return function (n) {
        var $15 = Data_Map_Internal.fromFoldable(dictOrd)(Data_Foldable.foldableArray);
        var $16 = Data_Array.take(n);
        var $17 = Data_Map_Internal.toUnfoldable(Data_Unfoldable.unfoldableArray);
        return function ($18) {
            return $15($16($17($18)));
        };
    };
};
var restrictKeys = function (dictOrd) {
    return function (map) {
        return function (keys) {
            return Data_Map_Internal.filterKeys(dictOrd)(function (v) {
                return Data_Foldable.elem(Data_Set.foldableSet)(dictOrd.Eq0())(v)(keys);
            })(map);
        };
    };
};
var partitionWithKey = function (dictOrd) {
    return function (p) {
        return function (m) {
            var parts = Data_Array.partition(function (v) {
                return p(v.value0)(v.value1);
            })(Data_Map_Internal.toUnfoldable(Data_Unfoldable.unfoldableArray)(m));
            return {
                yes: Data_Map_Internal.fromFoldable(dictOrd)(Data_Foldable.foldableArray)(parts.yes),
                no: Data_Map_Internal.fromFoldable(dictOrd)(Data_Foldable.foldableArray)(parts.no)
            };
        };
    };
};
var mapKeys = function (dictOrd) {
    return function (f) {
        return function (m) {
            return Data_Map_Internal.fromFoldable(dictOrd)(Data_Foldable.foldableArray)(Data_Functor.map(Data_Functor.functorArray)(function (v) {
                return new Data_Tuple.Tuple(f(v.value0), v.value1);
            })(Data_Map_Internal.toUnfoldable(Data_Unfoldable.unfoldableArray)(m)));
        };
    };
};
var findWithDefault = function (dictOrd) {
    return function (d) {
        return function (k) {
            var $19 = Data_Maybe.fromMaybe(d);
            var $20 = Data_Map_Internal.lookup(dictOrd)(k);
            return function ($21) {
                return $19($20($21));
            };
        };
    };
};
var drop = function (dictOrd) {
    return function (n) {
        var $22 = Data_Map_Internal.fromFoldable(dictOrd)(Data_Foldable.foldableArray);
        var $23 = Data_Array.drop(n);
        var $24 = Data_Map_Internal.toUnfoldable(Data_Unfoldable.unfoldableArray);
        return function ($25) {
            return $22($23($24($25)));
        };
    };
};
export {
    partitionWithKey,
    restrictKeys,
    mapKeys,
    take,
    drop,
    findWithDefault
};
//# sourceMappingURL=index.js.map
